module.exports = __webpack_public_path__ + "img/degustation.f4a93510.png";